export enum EventsTab {
  All,
  Upcoming,
}

export const TAG = 'Events';
